import { createContext, useContext } from 'react';
var RcResponsiveContext = createContext(undefined);
var useResponsiveContext = function () {
    return useContext(RcResponsiveContext);
};
export { RcResponsiveContext, useResponsiveContext };
